import React from "react";

function StarTwoIcon({ fill, ...restProps }) {
  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill ?? ""}
      {...restProps}
    >
      <path
        d="M9.109 5.358c-.478.967-.915 1.822-.972 1.9-.13.177-.325.32-.554.406-.112.042-.898.172-2.138.353-1.078.158-1.964.291-1.968.295-.004.004.651.649 1.456 1.432 1.336 1.3 1.474 1.445 1.574 1.648.175.357.162.516-.218 2.706-.177 1.016-.315 1.854-.307 1.862.008.008.799-.397 1.758-.901.959-.503 1.796-.936 1.86-.962.154-.062.646-.062.8 0 .064.026.901.459 1.86.962.959.503 1.751.908 1.759.9.008-.008-.13-.846-.307-1.862-.382-2.189-.394-2.348-.219-2.705.101-.204.238-.347 1.574-1.648a91.671 91.671 0 0 0 1.456-1.432c-.004-.004-.89-.137-1.968-.295-1.24-.181-2.026-.311-2.138-.353a1.216 1.216 0 0 1-.554-.406c-.057-.078-.494-.933-.972-1.9C10.413 4.391 10.012 3.6 10 3.6c-.012 0-.413.791-.891 1.758"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default StarTwoIcon;
